import { useQuery } from '@apollo/client';
import GET_FREE_USERS from '../../../queries/freeLicensesQueries/getFreeUsers';
import { PAGE_MODE } from '../../../constants/pageModeTypes';

export const useUserFreeDataQuery = (pageMode, orgId, orgUnitId, callback) => {
  const { error } = useQuery(GET_FREE_USERS, {
    variables: {
      organizationId: !orgUnitId ? orgId : null,
      orgUnitId: orgUnitId
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      const result = {
        orgUsers: data.freeUsers.OrgUsers,
        orgUnitUsers: data.freeUsers.OrgUnitUsers,
        orgLicenseCount:
          pageMode === PAGE_MODE.FDAVipOrg ||
          pageMode === PAGE_MODE.MDICVipOrg ||
          pageMode === PAGE_MODE.MddapOrg
            ? data.licenseInformation.Organization.licenseTotal
            : null,
        orgAssignedLicenseCount:
          pageMode === PAGE_MODE.FDAVipOrg ||
          pageMode === PAGE_MODE.MDICVipOrg ||
          pageMode === PAGE_MODE.MddapOrg
            ? data.licenseInformation.Organization.licenseAssigned
            : null,
        orgUnits: pageMode === PAGE_MODE.MddapOrg ? data.licenseInformation.OrgUnits : null,
        orgUnitLicenseCount: orgUnitId ? data.licenseInformation.OrgUnits[0].licenseTotal : null,
        orgUnitAssignedLicenseCount: orgUnitId
          ? data.licenseInformation.OrgUnits[0].licenseAssigned
          : null
      };

      callback(result);
    }
  });

  return { error };
};
